import store from "@/store";
import Vue from "vue";
import * as types from "@/store/constants/types";
import Http from "@/api/http/fetch/index";
import { isIos } from "@/utils/lodash";
import NumUtils from "@/utils/numUtils";
import * as statusConst from "@/store/constants/status";
import { transformResult } from "@/utils/localizedUtil";
import { judgeVersion } from "@/utils/judgeVersion";
import { findLastIndex } from "lodash";

const GeneralUtilsHelper: any = {
  isVisitor: () => {
    if (
      store.state.masterUserId === null &&
      store.state.userList.length !== 0
    ) {
      return true;
    } else {
      return false;
    }
  },
  isEmptyAccount: () => {
    if (
      store.state.currentUserId === null ||
      store.state.userList.length === 0
    ) {
      return true;
    } else {
      return false;
    }
  },
  findContinusTimesShowName: (
    key: string,
    interrupt_key: string,
    array: []
  ) => {
    const lastKeyIndex = findLastIndex(array, key);
    let continusTimes: number = 0;

    for (let i = array.length - lastKeyIndex; i >= 0; i--) {
      if (array[i] === key) {
        continusTimes += 1;
      }
      if (array[i] === interrupt_key) {
        break;
      }
    }
    console.log("findContinusTimesShowName:", continusTimes);
    return continusTimes;
  },
  isLoginUser: () => {
    //判断是否登陆过的用户，需要遍历userList，是否包含登陆的用户：
    for (const user of store.state.userList) {
      if (user.userType === "login") {
        return true;
      }
    }
    return false;
    // return store.state.masterUserId !== null;
  },
  isPirvateAccount: (userInfo: any) => {
    return userInfo.hasOwnProperty("is_private") && userInfo.is_private
      ? true
      : false;
  },
  isBlockComment: (mediaInfo: any) => {
    return (
      mediaInfo.hasOwnProperty("comments_disabled") &&
      mediaInfo.comments_disabled
    );
  },
  isNeedLinkVip: () => {
    console.log(
      "isNeedLinkVip结果：是否登陆和是否是vip",
      GeneralUtilsHelper.isLoginUser(),
      GeneralUtilsHelper.isVip()
    );
    return !GeneralUtilsHelper.isLoginUser() && GeneralUtilsHelper.isVip();
  },
  isColdingOrWarningUser: (userId: number) => {
    //判断是否被gx colding:
    if (
      store.state.gxUserInfoModule.gxUserInfo &&
      store.state.gxUserInfoModule.gxUserInfo.connections
    ) {
      const { connections } = store.state.gxUserInfoModule.gxUserInfo;
      const findUser = connections.find((user: any) => {
        return user.user_id === userId.toString();
      });
      if (
        findUser &&
        findUser.punish_level &&
        (findUser.punish_level === "colding" ||
          findUser.punish_level === "warning") &&
        findUser.punish_expire > new Date().valueOf()
      ) {
        return {
          punish_expire: findUser.punish_expire,
          punish_level: findUser.punish_level
        };
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  isBannedUser: (userId: number) => {
    //是否在status里面被标记：
    const findBannedUser = store.state.userStatusModule.userStatusList.find(
      (user: any) => {
        return user.userId === userId && user.status === statusConst.BANNED;
      }
    );
    if (findBannedUser) {
      return {
        punish_expire: 0,
        punish_level: "black_name"
      };
    }

    if (
      store.state.gxUserInfoModule.gxUserInfo &&
      store.state.gxUserInfoModule.gxUserInfo.connections
    ) {
      const { connections } = store.state.gxUserInfoModule.gxUserInfo;
      const findUser = connections.find((user: any) => {
        return user.user_id === userId.toString();
      });
      if (
        findUser &&
        findUser.punish_level &&
        (findUser.punish_level === "black_name" &&
          findUser.punish_expire > new Date().valueOf())
      ) {
        return {
          punish_expire: findUser.punish_expire,
          punish_level: findUser.punish_level
        };
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  isEarnCoinLimitedUser: (userId: number) => {
    if (store.state.userStatusModule.userStatusList) {
      const { userStatusList } = store.state.userStatusModule;
      const findUser = userStatusList.find((user: any) => {
        return user.userId === userId;
      });
      if (
        findUser &&
        findUser.status &&
        findUser.status === statusConst.TIME_LIMIT &&
        findUser.limitedEndTimeStamp &&
        findUser.limitedEndTimeStamp > new Date().valueOf()
      ) {
        return {
          limitedEndTimeStamp: findUser.limitedEndTimeStamp
        };
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  isLoginRequiredUser: (userId: number) => {
    if (store.state.userStatusModule.userStatusList) {
      const { userStatusList } = store.state.userStatusModule;
      const findUser = userStatusList.find((user: any) => {
        return user.userId === userId;
      });
      if (
        findUser &&
        findUser.insStatus &&
        findUser.insStatus === statusConst.LOGIN_REQUIRED
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  },
  isVip: () => {
    return (
      GeneralUtilsHelper.isValidVipInGxUserInfo() ||
      Boolean(GeneralUtilsHelper.isValidVipInServicelist())
    );
  },
  // (this.gxUserInfo.services.expire - this.gxUserInfo.services.server_current_time)/60/1000

  // 如果快过期返回日期，否则返回false
  isReadyExpireVip: () => {
    const findService = store.state.gxUserInfoModule.gxUserInfo.services.find(
      (service: any) => {
        return service.kind === "vip";
      }
    );
    return findService.hasOwnProperty("expire")
      ? Math.floor(
          (findService.expire -
            store.state.gxUserInfoModule.gxUserInfo.server_current_time) /
            60 /
            60 /
            24 /
            1000
        )
      : false;
  },

  // 获取当前服务器时间
  getCurrentServeTime: () => {
    return store.state.gxUserInfoModule.gxUserInfo.server_current_time;
  },

  // 判断gxUserInfo内的services是否有有效的vip
  isValidVipInGxUserInfo: () => {
    if (
      store.state.gxUserInfoModule.gxUserInfo == null ||
      !store.state.gxUserInfoModule.gxUserInfo.hasOwnProperty("services")
    ) {
      console.log(
        "masterServic为空",
        store.state.gxUserInfoModule.gxUserInfo,
        store.state.gxUserInfoModule.gxUserInfo.hasOwnProperty("services")
      );
      return false;
    } else {
      const findService = store.state.gxUserInfoModule.gxUserInfo.services.find(
        (service: any) => {
          return service.kind === "vip";
        }
      );
      return findService === undefined
        ? false
        : findService.hasOwnProperty("expire")
        ? findService.expire >=
          store.state.gxUserInfoModule.gxUserInfo.server_current_time
        : true;
    }
  },

  // 判断serviceList里面是否有有效的vip
  isValidVipInServicelist: () => {
    const currentTime = GeneralUtilsHelper.getCurrentServeTime();
    return (
      store.state.gxUserInfoModule &&
      store.state.gxUserInfoModule.gxServiceList &&
      store.state.gxUserInfoModule.gxServiceList.find(
        (service: any) =>
          service.service_type === "vip" &&
          service.expiration_timestamp > currentTime
      )
    );
  },

  // 获取当前有效的vip的name，如果没有，则代表当前绑定的是设备id，还没有加粉用户
  isValidVipInsUser: () => {
    const currentTime = GeneralUtilsHelper.getCurrentServeTime();
    const userList = store.state.userList;
    return (
      store.state.gxUserInfoModule &&
      store.state.gxUserInfoModule.gxServiceList &&
      store.state.gxUserInfoModule.gxServiceList.find(
        (service: any) =>
          service.service_type === "vip" &&
          service.expiration_timestamp > currentTime &&
          userList.find(
            (v: any) => v.userId.toString() === service.target_user_id
          )
      )
    );
  },

  isValidVipBind: () => {
    const validVip = GeneralUtilsHelper.isValidVipInServicelist();
    return (
      validVip && validVip.target_user_id && !isNaN(validVip.target_user_id)
    );
  },

  isSearch: (userId: number) => {
    const { userList } = store.state;
    const findUser = userList.find((user: any) => {
      return user.userId === userId;
    });
    return findUser === undefined
      ? false
      : findUser.userType === "login"
      ? false
      : true;
  },
  isDoubleCoins: () => {
    const { settingData } = store.state.settingModule;
    try {
      const currentTime = new Date().valueOf();
      const sale = settingData.coin_limit_sale;
      if (!sale) {
        return false;
      }
      if (currentTime >= sale.start_time && currentTime <= sale.end_time) {
        const { percentage } = sale;
        if (
          percentage &&
          GeneralUtilsHelper.isDoubleCoinsPercentageValid(percentage)
        ) {
          return true;
        }
        return false;
      }
      return false;
    } catch (error) {
      return false;
    }
  },
  isDoubleCoinsPercentageValid: (percentage: number) => {
    return percentage === 200 || percentage === 300 || percentage === 400;
  },
  isHalfCoins: () => {
    const { settingData } = store.state.settingModule;
    try {
      const currentTime = new Date().valueOf();
      return settingData.coin_half_sale
        ? currentTime >= settingData.coin_half_sale.start_time &&
            currentTime < settingData.coin_half_sale.end_time
        : false;
    } catch (error) {
      return false;
    }
  },
  localizePriceShift: (payload: any) => {
    const localizeData = store.getters[types.GETTER_LOCALIZE_PRICE_DATA];
    if (localizeData) {
      const reProcessPrice = () => {
        if (typeof payload === "string") {
        } else if (typeof payload === "number") {
        }
      };
    } else {
      return payload;
    }
  },
  hasRedirect: () => {
    const { settingData } = store.state.settingModule;
    try {
      if (settingData.hasOwnProperty("redirect_app")) {
        const redirectApp = settingData.redirect_app;
        if (
          redirectApp.hasOwnProperty("switch") &&
          redirectApp.switch === true
        ) {
          if (redirectApp.is_force_redirect) {
            return {
              name: "is_force_redirect",
              value: redirectApp.app_url
            };
          } else {
            return {
              name: "is_safe_redirect",
              value: redirectApp.app_url
            };
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  isSubsOffer: (offer: any) => {
    //判断这个offer是否是订阅类型的offer
    try {
      let result: boolean;
      if (offer.kind.indexOf("vip") > -1) {
        return true;
        // result = !GeneralUtilsHelper.getIapTypeByServiceOffer(offer.offer_id);
      } else {
        result = offer.hasOwnProperty("subscription");
      }
      return result;
    } catch (error) {
      return false;
    }
  },
  isPostOffer: (offer: any) => {
    try {
      const { kind } = offer;
      switch (kind) {
        case "like":
          return true;
        case "view":
          return true;
        case "comment":
          return true;
        case "special_like":
          return true;
        default:
          return false;
      }
    } catch (error) {
      return false;
    }
  },
  isPrivate: (userInfo: any) => {
    try {
      return userInfo.hasOwnProperty("is_private") && userInfo.is_private;
    } catch (error) {
      return false;
    }
  },
  hasPurchasedIap: () => {
    try {
      const gxUserInfo = store.getters[types.GETTER_MASTER_SERVICE_DATA];
      if (
        gxUserInfo &&
        gxUserInfo.iap_buy_total_count &&
        gxUserInfo.iap_buy_total_count > 0
      ) {
        return true;
      } else {
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  /**
   *  传入单个的post信息，转换出数量和post的url
   */
  getInsPostData: (media: any) => {
    const resultObj = {
      pic_url: "",
      like_count: 0,
      comment_count: 0,
      view_count: 0,
      type_icon: "",
      id: "",
      media_type: ""
    };
    if (media === null || media === undefined) {
      return resultObj;
    }
    if (media.media_type === 8) {
      resultObj.pic_url =
        media.carousel_media[0].image_versions2.candidates[0].url;
      resultObj.type_icon = require("@/assets/icons-file/sku/multi_pic.png");
    } else {
      resultObj.pic_url = media.image_versions2.candidates[0].url;
    }
    if (media.media_type === 2) {
      resultObj.view_count = media.hasOwnProperty("view_count")
        ? media.view_count
        : 0;
      resultObj.type_icon = require("@/assets/icons-file/sku/movies_pic.png");
    }
    media.hasOwnProperty("comment_count")
      ? (resultObj.comment_count = media.comment_count)
      : (resultObj.comment_count = media.comment_count = 0);
    media.hasOwnProperty("like_count")
      ? (resultObj.like_count = media.like_count)
      : (resultObj.like_count = media.like_count = 0);
    return resultObj;
  },
  /**
   * 传入offer返回出当前的resource
   */
  getResourceFromOffer: (offer: any) => {
    // if (offer.offer) {
    //   offer = offer.offer;
    // }
    const { kind } = offer;
    let username, full_name, profile_pic_url, follower_count;

    //一般的offer给当前帐号去购买:
    let user_id =
      (store.getters[types.GETTER_CURRENT_INS_USER_ID] &&
        store.getters[types.GETTER_CURRENT_INS_USER_ID].toString()) ||
      store.getters[types.GETTER_DEVICE_ID];
    const user_info =
      (store.getters[types.GETTER_CURRENT_INS_USER_INFO] &&
        store.getters[types.GETTER_CURRENT_INS_USER_INFO].insUserInfo) ||
      null;
    const user_coin = store.getters[types.GETTER_MASTER_COINS];
    username = (user_info && user_info.username) || null;
    full_name = (user_info && user_info.full_name) || null;
    profile_pic_url = (user_info && user_info.profile_pic_url) || null;
    follower_count = (user_info && user_info.follower_count) || null;

    //如果是vip或者买coin的话，只能买给主账户：
    if (kind.indexOf("vip") > -1 || kind.indexOf("coin") > -1) {
      // if (!GeneralUtilsHelper.isLoginUser()) {
      //   ///如果是vip在随便看看模式下购买user_id为divice_id,没有主账号的头像或者名字
      //   user_id = store.getters[types.GETTER_DEVICE_ID];
      //   username = null;
      //   full_name = null;
      //   profile_pic_url = null;
      //   follower_count = null;
      // } else {
      //   //user_id为主账户,主账号有名字和头像
      //   user_id = store.getters[types.GETTER_MASTER_ID].toString();
      //   const master_id = store.getters[types.GETTER_MASTER_ID];
      //   const userInfo = store.getters[types.GETTER_INS_USER_INFO_BY_ID](
      //     master_id
      //   );
      //   username = userInfo.insUserInfo.username;
      //   full_name = userInfo.insUserInfo.full_name;
      //   profile_pic_url = userInfo.insUserInfo.profile_pic_url;
      //   follower_count = userInfo.insUserInfo.follower_count;
      // }

      user_id = store.getters[types.GETTER_DEVICE_ID];
      username = null;
      full_name = null;
      profile_pic_url = null;
      follower_count = null;
    } else if (offer.subs_resource) {
      user_id = offer.subs_resource.user_id;
      username = offer.subs_resource.username;
      full_name = offer.subs_resource.full_name;
      profile_pic_url = offer.subs_resource.profile_pic_url;
      follower_count = offer.subs_resource.follower_count;
    }

    let resource: any = {
      user_id,
      user_coin,
      username,
      full_name,
      profile_pic_url,
      follower_count
    };
    //从offer只给你判断是post还是view的media
    let media = null;
    if (offer.kind === "view") {
      media = store.getters[types.GETTER_CURRENT_INS_MEDIA_INFO]("view");
    } else {
      media = store.getters[types.GETTER_CURRENT_INS_MEDIA_INFO]("post");
    }
    const media_info: any = GeneralUtilsHelper.getInsPostData(media);
    const url = (media_info && media_info.pic_url) || null;
    const id = (media && media.id) || null;
    const media_type = (media && media.media_type) || null;
    //只有post类型的才走下面代码逻辑
    if (GeneralUtilsHelper.isPostOffer(offer)) {
      resource = {
        ...resource,
        media_id: id,
        media_type,
        image_thumb: url,
        image_low: url,
        image_high: url
      };
    }

    //判断kind的时候类型：
    if (kind.indexOf("follow") > -1) {
      resource.initial_count = (user_info && user_info.follower_count) || 0;
    } else if (kind.indexOf("like") > -1) {
      resource.initial_count = (media_info && media_info.like_count) || 0;
    } else if (kind.indexOf("view") > -1) {
      resource.initial_count = (media_info && media_info.view_count) || 0;
    } else if (kind.indexOf("comment") > -1) {
      resource.initial_count = (media_info && media_info.comment_count) || 0;
    } else {
      resource.initial_count = (user_info && user_info.follower_count) || 0;
    }

    //如果哪个参数为null或者undefinded就去删除掉:
    for (const key in resource) {
      if (resource.hasOwnProperty(key)) {
        resource[key] === undefined || resource[key] === null
          ? delete resource[key]
          : void 0;
      }
    }

    return resource;
  },
  paymentSwitch: () => {
    try {
      let paypal_enabled = false;
      let stripe_enabled = false;
      let iap_enabled = false;
      const settingData = store.getters[types.GETTER_SETTING_DATA];
      const threshold = store.getters[types.GETTER_PAYMENT_SWITCH_THRESHOLD];
      //灰度的判断是否开启开关：threshold[0-99]
      const { paymentWay } = settingData;
      const paypalItem = paymentWay.find((item: any) => {
        return item.type === "type_paypal";
      });
      const stripeItem = paymentWay.find((item: any) => {
        return item.type === "type_stripe";
      });
      const iapItem = paymentWay.find((item: any) => {
        return item.type === "type_self_iap";
      });
      if (paypalItem.isEnable > threshold) {
        paypal_enabled = true;
      }
      if (stripeItem.isEnable > threshold) {
        stripe_enabled = true;
      }
      if (iapItem.isEnable > threshold) {
        iap_enabled = true;
      }

      //服务器返回的user_info里面的字段来限制开关：只有当关闭的时候才去更新
      const masterServiceData = store.state.gxUserInfoModule.gxUserInfo;
      if (
        masterServiceData.hasOwnProperty("paypal_enabled") &&
        !masterServiceData.paypal_enabled
      ) {
        paypal_enabled = masterServiceData.paypal_enabled;
      }
      if (
        masterServiceData.hasOwnProperty("stripe_enabled") &&
        !masterServiceData.stripe_enabled
      ) {
        stripe_enabled = masterServiceData.stripe_enabled;
      }
      console.log("paymentSwitch result:", {
        paypal_enabled,
        stripe_enabled,
        iap_enabled
      });
      return {
        paypal_enabled,
        stripe_enabled,
        iap_enabled
      };
    } catch (error) {
      console.log("paymentSwitch error:", error);
      return {
        paypal_enabled: false,
        stripe_enabled: false,
        iap_enabled: true
      };
    }
  },
  localizePriceText: (offer: any) => {
    if (!offer) {
      return null;
    }

    if (isIos()) {
      return store.getters[types.GETTER_LOCALIZE_PRICE](offer.iap.product_id)
        ? `${
            store.getters[types.GETTER_LOCALIZE_PRICE](offer.iap.product_id)
              .localSymbol
          } ${NumUtils.toDecimal2(
            store.getters[types.GETTER_LOCALIZE_PRICE](offer.iap.product_id)
              .price
          )}`
        : offer.iap.price;
    } else {
      return "$ " + offer.iap.price.slice(1);
    }
  },
  localizePriceOriginalText(offer: any, format?: boolean) {
    if (!offer) {
      return null;
    }

    const discount = offer.discount ? offer.discount : 0;
    const originalPrice: number =
      offer.iap && offer.iap.hasOwnProperty("price") //原价
        ? Math.floor(
            (parseFloat(offer.iap.price.substring(1)) / (1 - discount / 100)) *
              100
          ) / 100
        : 0;
    if (isIos()) {
      const localizePrice: any = store.getters[types.GETTER_LOCALIZE_PRICE](
        offer.iap.product_id
      );
      let price: any;
      let result: any;
      if (localizePrice) {
        price = NumUtils.toDecimal2(
          Math.floor((localizePrice.price / (1 - discount / 100)) * 100) / 100
        );
        result = `${localizePrice.localSymbol} ${
          format ? transformResult(price) : price
        }`;
      } else {
        price = originalPrice;
        result = `$ ${format ? transformResult(price) : price}`;
      }
      return result;
    } else {
      return `$ ${originalPrice}`;
    }
  },
  isVnode: (node: any) => {
    try {
      return typeof node === "object" && node.hasOwnProperty("elm");
    } catch (error) {
      return false;
    }
  },
  isVueComponent: (component: any) => {
    try {
      if (component !== undefined) {
        console.log("isVueComponent:", {
          component
        });
      }
      return (
        component !== undefined &&
        typeof component === "object" &&
        component.hasOwnProperty("$refs")
      );
    } catch (error) {
      console.log("isVueComponent error", error);
      return false;
    }
  },
  clickContact: async () => {
    const masterId = store.getters[types.GETTER_MASTER_ID];
    const deviceId = store.getters[types.GETTER_DEVICE_ID];
    const userInfo = store.getters[types.GETTER_INS_USER_INFO_BY_ID];
    const userId = masterId ? masterId.toString() : deviceId;
    const AppInfo: any = await Http.AppInfo();
    let username: any;
    if (
      masterId &&
      userInfo(masterId) &&
      userInfo(masterId).insUserInfo &&
      userInfo(masterId).insUserInfo.username
    ) {
      username = userInfo(masterId).insUserInfo.username;
    } else {
      username = deviceId;
    }

    let email: any = "team@likerushapp.com";
    if (
      store.getters[types.GETTER_SETTING_DATA] &&
      store.getters[types.GETTER_SETTING_DATA].feedback
    ) {
      email = store.getters[types.GETTER_SETTING_DATA].feedback.support_email;
    }

    let vip = false;
    if (GeneralUtilsHelper.isVip()) {
      vip = true;
    }

    const sendData: any = {
      userId,
      username,
      vip,
      email
    };

    if (AppInfo.APP_NAME && AppInfo.VERSION_NAME) {
      let title = `[ ${AppInfo.APP_NAME} ${AppInfo.VERSION_NAME} ]`;
      if (
        store.getters[types.GETTER_MASTER_SERVICE_DATA] &&
        store.getters[types.GETTER_MASTER_SERVICE_DATA].xmail
      ) {
        // sendData.xmail = store.getters[types.GETTER_MASTER_SERVICE_DATA].xmail;
        const xmail = store.getters[types.GETTER_MASTER_SERVICE_DATA].xmail;
        title = `[ ${AppInfo.APP_NAME} ${AppInfo.VERSION_NAME}.${xmail} ]`;
      }
      sendData.title = title;
    }

    Http.ShowEmail(sendData)
      .then(res => {
        Vue.prototype.resData = res;
        if (Vue.prototype.resData.status === "fail") {
          Vue.prototype.$Toast.show({
            type: "failure",
            content: "Please add an email account in System app:Mail"
          });
        }
      })
      .catch(res => {});
  },

  // 判断是否弹出签到 1、最后签到时间存在，2、最后签到时间不是今天，3、有签到奖励存在
  judgeTodayCheckIn: () => {
    let last_checkin_time: any = 0;
    if (
      store.state.gxUserInfoModule.gxUserInfo &&
      store.state.gxUserInfoModule.gxUserInfo.last_checkin_time
    ) {
      last_checkin_time = store.state.gxUserInfoModule.gxUserInfo
        .last_checkin_time
        ? store.state.gxUserInfoModule.gxUserInfo.last_checkin_time
        : 0;
    }
    return (
      last_checkin_time &&
      new Date(last_checkin_time).toDateString() ===
        new Date(GeneralUtilsHelper.getCurrentServeTime()).toDateString()
    );
  },

  // 判断是否显示签到
  judgeCheckInReward: () => {
    return (
      store.state.settingModule &&
      store.state.settingModule.settingData &&
      store.state.settingModule.settingData.checkin_rewards
    );
  },

  /**
   * 格式化大额数字成 9,000,789 的格式
   */
  formatToThousands: (num: number) => {
    return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,");
  },
  /*
   * ios判断版本号 true则版本号满足情况
   * */
  iosJudgeVersion: async (reqVersion: string) => {
    return new Promise(async (resolve, reject) => {
      const appInfo: any = await Http.AppInfo();
      const result =
        appInfo &&
        appInfo.CODE_VERSION &&
        judgeVersion(appInfo.CODE_VERSION, reqVersion);
      resolve(result);
    });
  },
  isRedirect: () => {
    return (
      (store.getters[types.GETTER_HAS_REDIRECT] &&
        store.getters[types.GETTER_APP_TAKE_DOWN]) ||
      (store.getters[types.GETTER_APP_TAKE_DOWN] &&
        store.getters[types.GETTER_BACK_UP_APP_SHOW_ENABLE] &&
        (store.getters[types.GETTER_BACK_UP_APP_PARAMS] &&
          store.getters[types.GETTER_BACK_UP_APP_PARAMS]
            .take_down_launch_enabled))
    );
  }
};
export default GeneralUtilsHelper;
